import { Boxscore } from "../../lib/types/statsApi";
import _uniq from "lodash/uniq";

export class TeamAndPlayerStateManager {
  #boxscore?: Boxscore;

  constructor() {
    this.#boxscore = undefined;
  }

  getTeams() {
    return this.#boxscore?.teams;
  }

  getHomeTeam() {
    return this.#boxscore?.teams.home;
  }

  getAwayTeam() {
    return this.#boxscore?.teams.away;
  }

  getAwayPlayersParentTeamIds() {
    if (this.#boxscore?.teams.away.players) {
      return _uniq(
        Object.keys(this.#boxscore?.teams.away.players).map(
          (key) => this.#boxscore?.teams.away.players[key].parentTeamId
        )
      );
    }
  }

  getHomePlayersParentTeamIds() {
    if (this.#boxscore?.teams.away.players) {
      return _uniq(
        Object.keys(this.#boxscore?.teams.home.players).map(
          (key) => this.#boxscore?.teams.home.players[key].parentTeamId
        )
      );
    }
  }

  setBoxscoreInformation(boxscore: Boxscore) {
    this.#boxscore = boxscore;
  }
}
